// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_YKJEo","menu":"menu_7--Xt","fixedShow":"fixedShow_nhVDF"};